export default {
    locale: state => {
        return state.locale
    },
    locales: state => {
        return state.locales
    },
}
